import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from './SessionProvider';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isManagerLoggedIn } = useSession();
  const location = useLocation();

  if (!isManagerLoggedIn) {
    // Redirect to login, preserving the attempted URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
